import React, { useState, useEffect } from 'react';
import { Card, Button, Upload, Typography, Progress, message } from 'antd';
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Dragger } = Upload;
const { Title } = Typography;

const UpdateAddress = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [importId, setImportId] = useState(null);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState(null);
  const [errorDetails, setErrorDetails] = useState(null);

  const handleDownloadTemplate = () => {
    window.location.href = "/templates/update_address.xlsx";
  };

  const handleUpload = (info) => {
    setFile(info.file);
  };

  const checkProgress = async (id) => {
    try {
      const response = await axios.get(`/api/orders/update_progress/${id}/`);
      const data = response.data;

      setProgress(data.percentage);
      setStatus(data.status);

      if (data.error_message) {
        setErrorDetails(data.error_message);
        message.error('更新地址时发生错误');
        setUploading(false);
        return;
      }

      if (data.status === 'COMPLETED') {
        message.success(`成功更新 ${data.successful_count} 个订单地址`);
        if (data.error_count > 0) {
          const errorMessage = data.error_orders.map(order => 
            `订单 ${order.order_number}: ${order.error}`
          ).join('\n');
          setErrorDetails(errorMessage);
          message.warning(`${data.error_count} 个订单更新失败`);
        }
        setUploading(false);
        return;
      }

      // Continue checking progress
      setTimeout(() => checkProgress(id), 1000);
    } catch (error) {
      console.error('Error checking progress:', error);
      message.error('检查更新进度时发生错误');
      setUploading(false);
    }
  };

  const handleConfirm = async () => {
    if (!file) {
      message.error('请先选择文件');
      return;
    }

    setUploading(true);
    setProgress(0);
    setErrorDetails(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post('/api/orders/update_address/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setImportId(response.data.import_id);
      checkProgress(response.data.import_id);
    } catch (error) {
      console.error('Error uploading file:', error);
      message.error('上传文件时发生错误');
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card title="更新地址">
        <div style={{ marginBottom: '24px' }}>
          <Title level={5}>下载模板</Title>
          <Button 
            icon={<DownloadOutlined />} 
            onClick={handleDownloadTemplate}
          >
            下载地址更新模板
          </Button>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <Title level={5}>上传文件</Title>
          <Dragger 
            name="file"
            multiple={false}
            onChange={handleUpload}
            beforeUpload={() => false}
            style={{ padding: '20px' }}
            disabled={uploading}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
            <p className="ant-upload-hint">支持单个文件上传，请使用下载的模板格式</p>
          </Dragger>
        </div>

        {uploading && (
          <div style={{ marginBottom: '24px' }}>
            <Progress percent={progress} status={status === 'ERROR' ? 'exception' : undefined} />
          </div>
        )}

        {errorDetails && (
          <div style={{ marginBottom: '24px', whiteSpace: 'pre-line' }}>
            <Title level={5} style={{ color: '#ff4d4f' }}>错误详情：</Title>
            <div style={{ color: '#ff4d4f' }}>{errorDetails}</div>
          </div>
        )}

        <Button 
          type="primary" 
          onClick={handleConfirm}
          style={{ width: '100%' }}
          loading={uploading}
          disabled={uploading}
        >
          确认更新
        </Button>
      </Card>
    </div>
  );
};

export default UpdateAddress;
